import { Suspense, lazy } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { LoadingBlock } from '@/ui/states'
import { AppLayout } from './AppLayout'
import { RequireAuth } from './RequireAuth'
import { LoginPage } from '@/features/auth/LoginPage'
import { HomePage } from '@/features/home/HomePage'
import { PortfolioPage } from '@/features/portfolio/PortfolioPage'
import { SiteOverviewPage } from '@/features/site/SiteOverviewPage'
import { AssetsPage } from '@/features/assets/AssetsPage'
import { AssetDetailPage } from '@/features/assets/AssetDetailPage'
import { AssessmentPage } from '@/features/assessment/AssessmentPage'
import { EvidencePage } from '@/features/evidence/EvidencePage'
import { UnderwritingPage } from '@/features/underwriting/UnderwritingPage'
import { ObligationsPage } from '@/features/obligations/ObligationsPage'
import { OperationsPage } from '@/features/operations/OperationsPage'
// Lazy: keeps three.js / R3F out of the initial bundle (loads on first twin visit).
const TwinPage = lazy(() => import('@/features/twin/TwinPage').then((m) => ({ default: m.TwinPage })))
import { AlertsPage } from '@/features/alerts/AlertsPage'
import { AdminPage } from '@/features/admin/AdminPage'
import { AccountPage } from '@/features/account/AccountPage'

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/home" replace /> },
      { path: 'home', element: <HomePage /> },
      { path: 'portfolio', element: <PortfolioPage /> },
      { path: 'alerts', element: <AlertsPage /> },
      { path: 'admin', element: <AdminPage /> },
      { path: 'account', element: <AccountPage /> },
      { path: 'site/:siteId', element: <SiteOverviewPage /> },
      { path: 'site/:siteId/assets', element: <AssetsPage /> },
      { path: 'site/:siteId/assets/:assetId', element: <AssetDetailPage /> },
      { path: 'site/:siteId/assessment', element: <AssessmentPage /> },
      { path: 'site/:siteId/evidence', element: <EvidencePage /> },
      { path: 'site/:siteId/underwriting', element: <UnderwritingPage /> },
      { path: 'site/:siteId/obligations', element: <ObligationsPage /> },
      { path: 'site/:siteId/operations', element: <OperationsPage /> },
      {
        path: 'site/:siteId/twin',
        element: (
          <Suspense fallback={<div className="p-2"><LoadingBlock lines={6} /></div>}>
            <TwinPage />
          </Suspense>
        ),
      },
    ],
  },
  { path: '*', element: <Navigate to="/home" replace /> },
])
